import { IdcardOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import type { ReactNode } from 'react';

export interface ViewDrawerTitleProps {
  title: string;
  errorCode?: string | null;
  accentColor?: string;
  accentBg?: string;
  icon?: ReactNode;
}

export function ViewDrawerTitle({
  title,
  errorCode,
  accentColor = 'var(--evimo-blue)',
  accentBg = 'color-mix(in srgb, var(--evimo-blue) 12%, transparent)',
  icon = <IdcardOutlined />,
}: ViewDrawerTitleProps) {
  return (
    <Flex align="center" gap={10}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          borderRadius: 8,
          background: accentBg,
          color: accentColor,
        }}
      >
        {icon}
      </span>
      <span>{title}</span>
      {errorCode ? (
        <Typography.Text
          code
          style={{
            marginInlineStart: 4,
            color: 'var(--evimo-blue)',
            background: 'color-mix(in srgb, var(--evimo-blue) 8%, transparent)',
            border: 'none',
          }}
        >
          {errorCode}
        </Typography.Text>
      ) : null}
    </Flex>
  );
}
